import { t } from '@hefe/i18n';
import { LoadingStatus, ResetPasswordSlice } from '@hefe/store';
import { Button, Col, message, Result, Row } from 'antd';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import bannerWhite from '../../../../assets/images/logo/banner_white.png';
import CustomForm, {
  FormField,
} from '../../../containers/core/components/form/custom-form';
import { useAppDispatch } from '../../../store/store';
import styles from './forgot-password.page.module.scss';

/* eslint-disable-next-line */
export interface ForogtPasswordProps {}

export function ForgotPasswordPage(props: ForogtPasswordProps) {
  const [successful, setSuccessful] = useState(false);

  const dispatch = useAppDispatch();
  const _resetPasswordState = useSelector(
    ResetPasswordSlice.resetPasswordState
  );
  const navigate = useNavigate();

  const handleSubmit = async (values: any) => {
    dispatch(ResetPasswordSlice.requestPasswordToken({ ...values }))
      .unwrap()
      .then((_) => setSuccessful(true))
      .catch((_) => message.error(t('errors.mail'), 10));
  };

  const fields: FormField[] = [
    {
      name: 'email',
      type: 'email',
      label: '',
      placeholder: t('email'),
      rules: [
        {
          required: true,
          type: 'email',
          message: t('form_errors.email'),
        },
      ],
    },
  ];

  const renderSuccess = () => {
    return (
      <Result
        status="success"
        title="Swish"
        subTitle={
          t('information_texts.sent_mail_if_known') +
          ' ' +
          t('information_texts.check_inbox')
        }
        extra={[
          <Button type="primary" onClick={() => navigate('/login')}>
            {t('back_to_login')}
          </Button>,
        ]}
      />
    );
  };

  const renderForm = () => {
    return (
      <div>
        <h3>{t('questions.forgot_password')}</h3>
        <CustomForm
          fields={fields}
          onSubmit={(values) => handleSubmit(values)}
          loading={_resetPasswordState.loadingStatus === LoadingStatus.LOADING}
          submitButtonText="request_password"
        />
        <Link to="/login">{t('back_to_login')}</Link>
      </div>
    );
  };

  return (
    <div className={styles['container']}>
      <Row align="middle">
        <Col md={12} xs={24}>
          <div className={styles['content']}>
            <img alt="Backcourt Logo" src={bannerWhite} width="60%" />
            <h1 className={styles['info-header']}>
              {t('information_texts.forgot_password')}
            </h1>
          </div>
        </Col>
        <Col md={12} xs={24}>
          <div className={styles['content']}>
            <div className={styles['login-panel']}>
              {successful ? renderSuccess() : renderForm()}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default ForgotPasswordPage;
